import { parseString } from 'xml2js'
import { useUserStore } from '.'
import { handleError } from '../../general/errorHandling'
import { getLocalForage, STAGE, URLs } from '../../general/helper'
import { IUrls } from '../../general/interfaces'

const pdfInformationKey = 'pdfWithAgencyInformation'
const serviceTicketKey = 'serviceTicket'
const agentIDHideArrayKey = 'warningHideArray'
const localForage = getLocalForage()

export const setServiceTicketFromLocalForage = async () => {
  const userStore = useUserStore()
  
  try {
    await localForage?.getItem(serviceTicketKey, (_error, value: string | null) => {
      if (value) {
        userStore.serviceTicket = value
      }
    })
  } catch (error) {
    handleError({ error, origin: 'setServiceTicketFromLocalForage' })
  }
}

export const setNewServiceTicket = async (serviceTicket: string | null) => {
  const userStore = useUserStore()

  try {
    await localForage?.setItem(serviceTicketKey, serviceTicket)
    userStore.serviceTicket = serviceTicket
  } catch (error) {
    handleError({ error, origin: 'setNewServiceTicket' })
  }
}

export const loginProcedure = async () => {
  const userStore = useUserStore()

  await localForage?.getItem(pdfInformationKey, (_error, value: boolean | null) => {
    if (value !== null) {
      userStore.pdfWithAgencyInformation = value
    }
  })

  await localForage?.getItem(agentIDHideArrayKey, (_error, value: string[] | null) => {
    if (value !== null && value.length && value.length > 0) {
      userStore.hideExpinetLeaveWarningArray = value
    }
  })

  await userStore.setServiceTicketFromLocalForage()

  if (!userStore.serviceTicket) {
    const url = window.location.href

    if (url.includes('?ticket=ST')) {
      const ticket = url.split('ticket=')[1]
      await userStore.setNewServiceTicket(ticket)
    } else {
      window.location.href = URLs[STAGE as keyof IUrls].login
      return
    }
  }

  const serviceTicket: string = userStore.serviceTicket ?? ''
  const response = await fetch(URLs[STAGE as keyof IUrls].validation + serviceTicket, {
    method: 'GET',
  })

  if (!response.ok) {
    document.body.innerHTML =
      'Leider ist der Login-Server nicht erreichbar, bitte versuchen Sie es später noch einmal oder informieren Sie uns über den Ausfall.'
    return
  }
  const responseText = await response.text()

  if (responseText.includes('yes')) {
    const netIDPosition = responseText.indexOf('NETID')
    const netId = responseText.substring(netIDPosition, responseText.length).replace('\n', '')

    userStore.netId = netId

    await userStore.setNewServiceTicket(null)
    await userStore.loadProfile()
  } else {
    await userStore.setNewServiceTicket(null)
    window.location.href = URLs[STAGE as keyof IUrls].login
  }
}

export const loadProfile = async () => {
  const userStore = useUserStore()
  const netId: string = userStore.netId ?? ''
  const response = await fetch(URLs[STAGE as keyof IUrls].profile + netId, {
    method: 'GET',
  }) 
  if (response.ok) {
    const text = await response.text()
    
    parseString(text, (_err, result) => {
      const profile = result.SessionHubProfile
      const person = profile.Person[0]
      const agency = profile.Agency[0]
      const employee = profile.AIDAEmployee[0]

      userStore.agencyId = agency.AgencyID[0]
      userStore.agentLogin = employee.AIDALogin[0]
      userStore.agentEmail = person.Email1[0]
      userStore.agentName = person.GivenName[0] + ' ' + person.FamilyName[0]
      userStore.agentId = person.PersonID[0]
      userStore.agencyName = agency.Name[0]
      userStore.agencyEmail = agency.Email[0]
      userStore.agencyPhone = agency.Phone[0]
      userStore.agencyCountry = agency.Country[0]
      userStore.expiCode = person.AgtCnt[0]
    })
  }
  else {
    handleError({error: new Error('load profile failed')})
  }
}

export const setPdfWithAgencyInformation = async (value: boolean) => {
  const userStore = useUserStore()
  userStore.pdfWithAgencyInformation = value
  await localForage?.setItem(pdfInformationKey, value)
}

export const setAddExpinetLeaveWarning = async (value: string) => {
  const userStore = useUserStore()
  const agentIDHideArray: string[] = userStore.getHideExpinetLeaveWarningArray

  if (!agentIDHideArray.includes(value)) {
    agentIDHideArray.push(value)
  }

  userStore.hideExpinetLeaveWarningArray = agentIDHideArray
  await localForage?.setItem(agentIDHideArrayKey, agentIDHideArray)
}

export default {
  setServiceTicketFromLocalForage,
  setNewServiceTicket,
  loginProcedure,
  loadProfile,
  setPdfWithAgencyInformation,
  setAddExpinetLeaveWarning,
}